import CryptoJS from 'crypto-js';
import { privateKey } from '@/settings'

// 加密数据并返回字符串
export function encryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), privateKey).toString();
}

// 解密数据并返回json
export function decryptData(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, privateKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}
